var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.137999994,11.5969997 C2.94199847,12.9662193 6.16677243,13.198403 9.13799999,12.2449997 C13.638,10.7509997 16.7609996,12.2764997 16.7609996,12.2764997 L16.7609996,1.62949997 C16.7609996,1.62949997 13.6514996,0.104000013 9.13799999,1.59799997 C6.16677243,2.55140328 2.94199847,2.31921955 0.137999994,0.94999999 L0.137999994,20.1739995",
    transform: "translate(-155.000000, -1291.000000) translate(140.000000, 1291.000000) translate(16.000000, 0.000000)",
    stroke: "#000",
    strokeWidth: 0.99,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.0041eefe6dca36117667e6b161ccf707.svg";
export { ForwardRef as ReactComponent };